import { serialize } from "object-to-formdata";
import request from "../../utils/request";

import {
  ProjectInput, ProjectView
} from "../../models/projectManagement";
import { Result } from "../../models/general";

export async function createProject(input: ProjectInput) {
  const response = await request.post<Result<ProjectView>>("Project/CreateProject", input);
  return response.data;
}

export async function getProjects() {
  const response = await request.get<Result<ProjectView[]>>("Project/GetProjects");
  return response.data;
}

export async function updateProject(input: ProjectInput) {
  const response = await request.put<Result<ProjectView>>("Project/UpdateProject", input);
  return response.data;
}

export async function getProject(projectId: number) {
  const response = await request.get<Result<ProjectView>>(`Project/GetProject/${projectId}`);
  return response.data;
}